<template>
    <div>
        <v-card class="mx-auto mt-4" max-width="95%" elevation="2">
            <!-- 탭 헤더 -->
            <v-tabs
                v-model="activeTab"
                color="primary"
                slider-color="primary"
                background-color="grey lighten-5"
                centered
                icons-and-text
                show-arrows
                class="elevation-1"
            >
                <v-tab class="tab-item">
                    <span class="tab-text">메인 퀴즈 메뉴</span>
                    <v-icon class="ml-2" size="20">mdi-view-dashboard</v-icon>
                </v-tab>
                <v-tab class="tab-item">
                    <span class="tab-text">오적완 슬라이드2</span>
                    <v-icon class="ml-2" size="20">mdi-image-multiple</v-icon>
                </v-tab>
                <v-tab class="tab-item">
                    <span class="tab-text">오적완 슬라이드 (구)</span>
                    <v-icon class="ml-2" size="20">mdi-image-multiple-outline</v-icon>
                </v-tab>
            </v-tabs>

            <!-- 탭 패널 -->
            <v-tabs-items v-model="activeTab">
                <!-- 1번 탭: 메인메뉴 (기존 메인 퀴즈 정보 관리) -->
                <v-tab-item>
                    <v-toolbar color="grey lighten-4" flat class="toolbar-custom flex-wrap">
                        <v-toolbar-title class="toolbar-title-custom">
                            <v-icon left color="primary" size="22">mdi-view-dashboard</v-icon>
                            <span class="toolbar-text">메인 퀴즈 정보 관리</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            small
                            fab
                            elevation="2"
                            @click="OnClick_CreateMainQuiz"
                        >
                            <v-icon color="white">mdi-plus</v-icon>
                        </v-btn>
                    </v-toolbar>

            <v-list>
                <v-container v-if="loadingData" class="text-center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </v-container>
                <v-row v-else dense>
                    <v-col
                        v-for="item in main_quiz_list"
                        :key="item.PID"
                        cols="12"
                        sm="6"
                        md="4"
                        lg="3"
                        xl="2"
                    >
                        <v-card
                            class="mx-auto"
                            :elevation="item.IS_ENABLE === 'Y' ? 2 : 1"
                            @click="OnClick_EditMainQuiz(item)"
                            style="cursor: pointer; max-width: 280px;"
                            :class="{'grey-lighten-4': item.IS_ENABLE !== 'Y'}"
                        >
                            <v-img
                                v-if="item.THUMB"
                                :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + item.THUMB"
                                height="80"
                                cover
                                :style="item.IS_ENABLE !== 'Y' ? 'filter: grayscale(100%); opacity: 0.6;' : ''"
                            >
                                <template v-slot:placeholder>
                                    <div class="d-flex align-center justify-center fill-height">
                                        <v-progress-circular
                                            color="grey-lighten-4"
                                            indeterminate
                                            size="20"
                                        ></v-progress-circular>
                                    </div>
                                </template>
                            </v-img>
                            <v-card-title 
                                :class="item.IS_ENABLE === 'Y' ? 'primary white--text' : 'grey darken-1 white--text'"
                                class="py-1 px-2"
                                style="font-size: 0.8rem; line-height: 1.2; min-height: 36px;"
                            >
                                <v-icon left color="white" size="16" class="mr-1">mdi-help-circle</v-icon>
                                <span style="overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;">{{ item.TITLE }}</span>
                            </v-card-title>
                            
                            <v-card-text :class="item.IS_ENABLE !== 'Y' ? 'grey--text text--darken-1' : ''" style="max-width: 100%; overflow-wrap: break-word; padding: 8px;" class="pa-2">
                                <div class="mb-1" style="max-width: 100%; word-break: break-word; line-height: 1.3;">
                                    <v-icon x-small :color="item.IS_ENABLE === 'Y' ? 'primary' : 'grey'" class="mr-1" style="font-size: 12px;">mdi-text</v-icon>
                                    <span class="text-caption font-weight-medium" style="font-size: 0.7rem;">설명:</span>
                                    <span class="text-caption ml-1" style="font-size: 0.7rem; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical;">{{ item.DESC }}</span>
                                </div>
                                <div class="mb-1 d-flex align-center" style="line-height: 1.3;">
                                    <v-icon x-small :color="item.IS_ENABLE === 'Y' ? 'info' : 'grey'" class="mr-1" style="font-size: 12px;">mdi-format-list-bulleted-type</v-icon>
                                    <span class="text-caption font-weight-medium" style="font-size: 0.7rem;">타입:</span>
                                    <span class="text-caption ml-1" style="font-size: 0.7rem;">{{ getQuizTypeLabel(item.QUIZ_TYPE) }}</span>
                                </div>
                                <div class="mb-1 d-flex align-center" style="line-height: 1.3;">
                                    <v-icon x-small :color="item.IS_ENABLE === 'Y' ? 'success' : 'grey'" class="mr-1" style="font-size: 12px;">mdi-star</v-icon>
                                    <span class="text-caption font-weight-medium" style="font-size: 0.7rem;">등급:</span>
                                    <span class="text-caption ml-1" style="font-size: 0.7rem;">{{ item.GRADE || '-' }}</span>
                                </div>
                                <div class="mb-1 d-flex align-center" style="line-height: 1.3;">
                                    <v-icon x-small :color="item.IS_ENABLE === 'Y' ? 'warning' : 'grey'" class="mr-1" style="font-size: 12px;">mdi-numeric</v-icon>
                                    <span class="text-caption font-weight-medium" style="font-size: 0.7rem;">문제:</span>
                                    <span class="text-caption ml-1" style="font-size: 0.7rem;">{{ item.STEP_COUNT || '-' }}</span>
                                </div>
                                <div class="mb-1 d-flex align-center" style="line-height: 1.3;">
                                    <v-icon x-small :color="item.IS_ENABLE === 'Y' ? 'error' : 'grey'" class="mr-1" style="font-size: 12px;">
                                        {{ item.IS_ENABLE === 'Y' ? 'mdi-check-circle' : 'mdi-close-circle' }}
                                    </v-icon>
                                    <span class="text-caption font-weight-medium" style="font-size: 0.7rem;">{{ item.IS_ENABLE === 'Y' ? '활성' : '비활성' }}</span>
                                </div>
                                <div class="mt-1 d-flex align-center" style="line-height: 1.2;">
                                    <v-icon x-small color="grey" class="mr-1" style="font-size: 10px;">mdi-clock-outline</v-icon>
                                    <span class="text-caption grey--text" style="font-size: 0.65rem;">{{ formatDate(item.CREATE_DT) }}</span>
                                </div>
                            </v-card-text>

                            <v-card-actions class="pa-1">
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="primary"
                                    x-small
                                    outlined
                                    @click.stop="OnClick_EditMainQuiz(item)"
                                    style="min-width: 50px; height: 24px; font-size: 0.7rem;"
                                >
                                    <v-icon x-small left style="font-size: 12px;">mdi-pencil</v-icon>
                                    수정
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
                <v-container v-if="!loadingData && main_quiz_list.length === 0" class="text-center">
                    <v-icon large color="grey lighten-1">mdi-information-outline</v-icon>
                    <p class="text-body-1 grey--text mt-2">등록된 메인 퀴즈가 없습니다.</p>
                </v-container>
            </v-list>
                </v-tab-item>

                <!-- 2번 탭: 오적완 슬라이드2 (SlideList_2.json) -->
                <v-tab-item>
                    <v-toolbar color="grey lighten-4" flat class="toolbar-custom flex-wrap">
                        <v-toolbar-title class="toolbar-title-custom">
                            <v-icon left color="primary" size="22">mdi-image-multiple</v-icon>
                            <span class="toolbar-text">오적완 슬라이드2 관리</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    :href="slideListUrl"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    color="lime accent-3"
                                    rounded
                                    elevation="2"
                                    small
                                    class="mx-2"
                                >
                                    <v-icon left color="black">mdi-open-in-new</v-icon>
                                    <span style="color:black">링크 열기</span>
                                </v-btn>
                            </template>
                            <span>새 탭에서 슬라이드 리스트 JSON 열기</span>
                        </v-tooltip>
                        <v-btn
                            color="primary"
                            small
                            fab
                            elevation="2"
                            @click="OnClick_CreateSlide"
                        >
                            <v-icon color="white">mdi-plus</v-icon>
                        </v-btn>
                    </v-toolbar>

                    <v-list class="pa-0">
                        <v-list-item class="section-header" style="background:#E3F2FD; min-height: 48px;">
                            <v-list-item-content>
                                <v-list-item-title class="text-h6 font-weight-bold">[ 슬라이드 리스트 ]</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider/>
                        
                        <!-- 플레이스먼트 키 입력 필드 -->
                        <v-list-item class="px-4 py-3" style="background:#FFF9E6; border-bottom: 1px solid #e0e0e0;">
                            <v-list-item-content>
                                <v-text-field
                                    label="광고 플레이스먼트 키"
                                    v-model="slide_data.ad_placement"
                                    outlined
                                    dense
                                    prepend-inner-icon="mdi-key-variant"
                                    hint="광고 플레이스먼트 키를 입력하세요"
                                    persistent-hint
                                />
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider/>

                        <v-container v-if="loadingSlideData" class="text-center py-8">
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        </v-container>

                        <draggable
                            v-else
                            v-model="slide_data.slides"
                            handle=".drag-handle"
                            @end="onSlideDragEnd"
                            class="slide-list-container"
                        >
                            <v-list-item
                                v-for="(item, idx) in slide_data.slides"
                                :key="idx"
                                class="px-4 py-3 slide-item"
                                :class="{'slide-item-disabled': item.is_enable !== 'Y'}"
                                style="min-height: auto; border-bottom: 1px solid #e0e0e0;"
                            >
                                <v-row no-gutters class="align-center">
                                    <v-col cols="12" md="1" class="pa-1 d-flex align-center justify-center">
                                        <v-icon class="drag-handle" color="grey" style="cursor: move;">mdi-drag</v-icon>
                                    </v-col>
                                    <v-col cols="12" md="2" class="pa-1">
                                        <div v-if="item.thumb" class="mt-1">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <img 
                                                        :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+item.thumb" 
                                                        alt="Image"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        :style="{
                                                            width: '60px',
                                                            height: '60px',
                                                            border: '2px solid #E0E0E0',
                                                            borderRadius: '4px',
                                                            objectFit: 'cover',
                                                            display: 'block',
                                                            cursor: 'pointer',
                                                            filter: item.is_enable !== 'Y' ? 'grayscale(100%) opacity(0.5)' : 'none'
                                                        }"
                                                    />
                                                </template>
                                                <img 
                                                    :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+item.thumb" 
                                                    alt="Image Preview"
                                                    style="width: 200px; height: 200px; border: 2px solid #E0E0E0; border-radius: 8px; object-fit: cover; display: block;"
                                                />
                                            </v-tooltip>
                                        </div>
                                        <div v-else class="d-flex align-center justify-center" style="width: 60px; height: 60px; border: 2px dashed #E0E0E0; border-radius: 4px;">
                                            <v-icon color="grey lighten-1">mdi-image-off</v-icon>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="3" class="pa-1">
                                        <div 
                                            class="text-body-2 font-weight-medium"
                                            :class="{'grey--text text--darken-1': item.is_enable !== 'Y'}"
                                        >
                                            {{ item.title || '(제목 없음)' }}
                                        </div>
                                        <div class="d-flex align-center mt-1">
                                            <v-chip
                                                x-small
                                                :color="getBadgeColor(item.badge)"
                                                text-color="white"
                                                class="mr-1"
                                                :style="item.is_enable !== 'Y' ? 'opacity: 0.6;' : ''"
                                            >
                                                {{ getBadgeLabel(item.badge) }}
                                            </v-chip>
                                            <v-chip
                                                x-small
                                                :color="item.is_enable === 'Y' ? 'success' : 'grey darken-2'"
                                                text-color="white"
                                            >
                                                {{ item.is_enable === 'Y' ? '활성' : '비활성' }}
                                            </v-chip>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="3" class="pa-1">
                                        <div class="text-caption grey--text">액션 타입</div>
                                        <div 
                                            class="text-body-2 font-weight-medium"
                                            :class="{'grey--text text--darken-1': item.is_enable !== 'Y'}"
                                        >
                                            {{ getActionTypeLabel(item.action_type) }}
                                        </div>
                                        <div 
                                            v-if="item.action_param" 
                                            class="text-caption mt-1"
                                            :class="{'grey--text text--darken-1': item.is_enable !== 'Y', 'grey--text': item.is_enable === 'Y'}"
                                            style="word-break: break-all;"
                                        >
                                            {{ item.action_param }}
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="2" class="pa-1">
                                        <div class="text-caption grey--text">순서</div>
                                        <div 
                                            class="text-body-2 font-weight-bold"
                                            :class="{'grey--text text--darken-1': item.is_enable !== 'Y'}"
                                        >
                                            {{ idx + 1 }}
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="1" class="pa-1 d-flex align-center justify-end">
                                        <v-btn
                                            color="primary"
                                            x-small
                                            fab
                                            @click="OnClick_EditSlide(idx)"
                                            class="mr-1"
                                        >
                                            <v-icon color="white" small>mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-btn
                                            color="error"
                                            x-small
                                            fab
                                            @click="OnClick_DeleteSlide(idx)"
                                        >
                                            <v-icon color="white" small>mdi-delete</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                        </draggable>

                        <v-container v-if="!loadingSlideData && slide_data.slides.length === 0" class="text-center py-8">
                            <v-icon large color="grey lighten-1">mdi-information-outline</v-icon>
                            <p class="text-body-1 grey--text mt-2">등록된 슬라이드가 없습니다.</p>
                        </v-container>

                        <v-divider class="my-1"/>

                        <!-- 저장 버튼 -->
                        <v-list-item class="px-4 py-4" style="background:#F5F5F5;">
                            <v-spacer></v-spacer>
                            <v-btn 
                                width="150px" 
                                color="success" 
                                large
                                elevation="2"
                                @click="OnSave_SlideList"
                                :loading="savingSlideData"
                            >
                                <v-icon left>mdi-content-save</v-icon>
                                저장
                            </v-btn>
                            <v-spacer></v-spacer>
                        </v-list-item>
                    </v-list>
                </v-tab-item>

                <!-- 3번 탭: 오적완 슬라이드 (구) - SlideList.json 조회용 -->
                <v-tab-item>
                    <v-toolbar color="grey lighten-4" flat class="toolbar-custom flex-wrap">
                        <v-toolbar-title class="toolbar-title-custom">
                            <v-icon left color="grey darken-2" size="22">mdi-image-multiple-outline</v-icon>
                            <span class="toolbar-text">오적완 슬라이드 (구) — SlideList.json</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    :href="slideListLegacyUrl"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    color="lime accent-3"
                                    rounded
                                    elevation="2"
                                    small
                                    class="mx-2"
                                >
                                    <v-icon left color="black">mdi-open-in-new</v-icon>
                                    <span style="color:black">링크 열기</span>
                                </v-btn>
                            </template>
                            <span>새 탭에서 SlideList.json 열기</span>
                        </v-tooltip>
                    </v-toolbar>

                    <v-list class="pa-0">
                        <v-list-item class="section-header" style="background:#EEEEEE; min-height: 48px;">
                            <v-list-item-content>
                                <v-list-item-title class="text-h6 font-weight-bold">[ 슬라이드 리스트 (구) ]</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider/>

                        <v-list-item class="px-4 py-3" style="background:#FAFAFA; border-bottom: 1px solid #e0e0e0;">
                            <v-list-item-content>
                                <v-text-field
                                    label="광고 플레이스먼트 키"
                                    v-model="slide_data_legacy.ad_placement"
                                    outlined
                                    dense
                                    readonly
                                    prepend-inner-icon="mdi-key-variant"
                                />
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider/>

                        <v-container v-if="loadingSlideDataLegacy" class="text-center py-8">
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        </v-container>

                        <v-list-item
                            v-else
                            v-for="(item, idx) in slide_data_legacy.slides"
                            :key="'legacy-'+idx"
                            class="px-4 py-3 slide-item"
                            :class="{'slide-item-disabled': item.is_enable !== 'Y'}"
                            style="min-height: auto; border-bottom: 1px solid #e0e0e0;"
                        >
                            <v-row no-gutters class="align-center">
                                <v-col cols="12" md="2" class="pa-1">
                                    <div v-if="item.thumb" class="mt-1">
                                        <img 
                                            :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+item.thumb" 
                                            alt=""
                                            :style="{
                                                width: '60px', height: '60px', border: '2px solid #E0E0E0',
                                                borderRadius: '4px', objectFit: 'cover', display: 'block',
                                                filter: item.is_enable !== 'Y' ? 'grayscale(100%) opacity(0.5)' : 'none'
                                            }"
                                        />
                                    </div>
                                    <div v-else class="d-flex align-center justify-center" style="width: 60px; height: 60px; border: 2px dashed #E0E0E0; border-radius: 4px;">
                                        <v-icon color="grey lighten-1">mdi-image-off</v-icon>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="3" class="pa-1">
                                    <div class="text-body-2 font-weight-medium" :class="{'grey--text text--darken-1': item.is_enable !== 'Y'}">
                                        {{ item.title || '(제목 없음)' }}
                                    </div>
                                    <div class="d-flex align-center mt-1">
                                        <v-chip x-small :color="getBadgeColor(item.badge)" text-color="white" class="mr-1" :style="item.is_enable !== 'Y' ? 'opacity: 0.6;' : ''">
                                            {{ getBadgeLabel(item.badge) }}
                                        </v-chip>
                                        <v-chip x-small :color="item.is_enable === 'Y' ? 'success' : 'grey darken-2'" text-color="white">
                                            {{ item.is_enable === 'Y' ? '활성' : '비활성' }}
                                        </v-chip>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="3" class="pa-1">
                                    <div class="text-caption grey--text">액션 타입</div>
                                    <div class="text-body-2 font-weight-medium" :class="{'grey--text text--darken-1': item.is_enable !== 'Y'}">
                                        {{ getActionTypeLabel(item.action_type) }}
                                    </div>
                                    <div v-if="item.action_param" class="text-caption mt-1" :class="{'grey--text text--darken-1': item.is_enable !== 'Y', 'grey--text': item.is_enable === 'Y'}" style="word-break: break-all;">
                                        {{ item.action_param }}
                                    </div>
                                </v-col>
                                <v-col cols="12" md="1" class="pa-1">
                                    <div class="text-caption grey--text">순서</div>
                                    <div class="text-body-2 font-weight-bold" :class="{'grey--text text--darken-1': item.is_enable !== 'Y'}">{{ idx + 1 }}</div>
                                </v-col>
                            </v-row>
                        </v-list-item>

                        <v-container v-if="!loadingSlideDataLegacy && slide_data_legacy.slides.length === 0" class="text-center py-8">
                            <v-icon large color="grey lighten-1">mdi-information-outline</v-icon>
                            <p class="text-body-1 grey--text mt-2">등록된 슬라이드가 없습니다.</p>
                        </v-container>
                    </v-list>
                </v-tab-item>
            </v-tabs-items>
        </v-card>

        <!-- 메인 퀴즈 생성/수정 다이얼로그 -->
        <v-dialog
            v-model="dialog_main_quiz"
            persistent
            max-width="900"
            scrollable
            :fullscreen="$vuetify.breakpoint.xsOnly"
            @keydown.esc="CloseMainQuizDialog"
        >
            <v-card>
                <v-card-title class="text-h6 primary white--text py-2 px-4">
                    <v-icon left color="white" size="20">{{ dialog_mode_edit ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
                    {{ dialog_mode_edit ? '메인 퀴즈 수정' : '메인 퀴즈 등록' }}
                </v-card-title>

                <v-card-text class="pa-4" style="max-height: 80vh; overflow-y: auto;">
                    <!-- 기본 정보 섹션 -->
                    <div class="mb-3">
                        <div class="d-flex align-center mb-2">
                            <v-icon color="primary" class="mr-2" size="20">mdi-information-outline</v-icon>
                            <h3 class="text-subtitle-1 font-weight-bold">기본 정보</h3>
                        </div>
                        <v-divider class="mb-2"></v-divider>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="dialog_title"
                                    label="제목 *"
                                    outlined
                                    dense
                                    prepend-inner-icon="mdi-format-title"
                                    :rules="[v => !!v || '제목을 입력해주세요']"
                                />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="dialog_desc"
                                    label="부가설명 *"
                                    outlined
                                    dense
                                    prepend-inner-icon="mdi-text"
                                    :rules="[v => !!v || '부가설명을 입력해주세요']"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-select
                                    v-model="dialog_quiz_type"
                                    :items="quiz_type_options"
                                    item-text="label"
                                    item-value="value"
                                    label="퀴즈 타입 *"
                                    outlined
                                    dense
                                    prepend-inner-icon="mdi-format-list-bulleted-type"
                                    :disabled="dialog_mode_edit"
                                    :rules="[v => !!v || '퀴즈 타입을 선택해주세요']"
                                />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model.number="dialog_grade"
                                    label="등급"
                                    type="number"
                                    min="1"
                                    outlined
                                    dense
                                    prepend-inner-icon="mdi-star"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model.number="dialog_step_count"
                                    label="문제 수"
                                    type="number"
                                    min="1"
                                    outlined
                                    dense
                                    prepend-inner-icon="mdi-numeric"
                                    @input="updateQuestionCategoryMap"
                                />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model.number="dialog_participate"
                                    label="참여율"
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    max="1"
                                    outlined
                                    dense
                                    prepend-inner-icon="mdi-percent"
                                    :disabled="dialog_mode_edit"
                                    :readonly="dialog_mode_edit"
                                    hint="참여율은 데이터베이스에서 자동으로 계산됩니다."
                                    persistent-hint
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <div class="mb-2">
                                    <label class="text-caption grey--text text--darken-1 mb-1 d-block">썸네일 이미지</label>
                                </div>
                                <v-img
                                    v-if="dialog_thumb_url"
                                    :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + dialog_thumb_url"
                                    max-height="150"
                                    contain
                                    class="mb-2"
                                ></v-img>
                                <v-file-input
                                    v-model="dialog_thumb_file"
                                    label="썸네일 이미지 선택"
                                    accept="image/*"
                                    prepend-icon="mdi-camera"
                                    outlined
                                    dense
                                    show-size
                                ></v-file-input>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-select
                                    v-model="dialog_is_enable"
                                    :items="yes_no_options"
                                    item-text="label"
                                    item-value="value"
                                    label="활성화 여부"
                                    outlined
                                    dense
                                    prepend-inner-icon="mdi-toggle-switch"
                                />
                            </v-col>
                        </v-row>
                    </div>

                           <!-- 레벨 설정 섹션 (가로세로 퀴즈 또는 객관식 퀴즈인 경우, DRAWING/NONSENSE 제외) -->
                           <div v-if="checkNeedsLevelSetting(dialog_quiz_type) && dialog_step_count && dialog_step_count > 0" class="mb-3">
                        <div class="d-flex align-center mb-2">
                            <v-icon color="primary" class="mr-2" size="20">mdi-format-list-numbered</v-icon>
                            <h3 class="text-subtitle-1 font-weight-bold">문제별 난이도 설정</h3>
                        </div>
                        <v-divider class="mb-2"></v-divider>
                        
                        <!-- 문제별 레벨 설정 영역 -->
                        <v-card outlined style="border-radius: 8px; overflow: hidden;">
                            <v-card-text class="pa-0">
                                <v-list dense>
                                    <v-list-item 
                                        v-for="(item, index) in question_level_map"
                                        :key="'level-' + index"
                                        :class="{'mb-0': index < question_level_map.length - 1}"
                                        style="border-bottom: 1px solid #e0e0e0; min-height: 48px;"
                                    >
                                        <v-list-item-avatar 
                                            color="grey lighten-3"
                                            size="32"
                                            class="mr-2"
                                        >
                                            <span class="grey--text text--darken-2 font-weight-bold" style="font-size: 0.85rem;">{{ index + 1 }}</span>
                                        </v-list-item-avatar>
                                        
                                        <v-list-item-content class="py-1">
                                            <v-list-item-title class="font-weight-medium" style="font-size: 0.9rem; line-height: 1.2;">
                                                {{ index + 1 }}번 문제
                                            </v-list-item-title>
                                            <v-list-item-subtitle style="font-size: 0.75rem; min-height: auto;">
                                                레벨 선택
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        
                                        <v-list-item-action class="my-0">
                                            <v-select
                                                v-model="item.level"
                                                :items="level_options"
                                                item-text="label"
                                                item-value="value"
                                                outlined
                                                dense
                                                hide-details
                                                :color="getLevelColor(item.level)"
                                                style="min-width: 130px; max-width: 150px;"
                                            >
                                                <template v-slot:selection="{ item }">
                                                    <v-chip
                                                        x-small
                                                        :color="getLevelColor(item.value)"
                                                        text-color="white"
                                                        class="font-weight-bold"
                                                    >
                                                        {{ item.label }}
                                                    </v-chip>
                                                </template>
                                                <template v-slot:item="{ item }">
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            <v-chip
                                                                x-small
                                                                :color="getLevelColor(item.value)"
                                                                text-color="white"
                                                                class="font-weight-bold"
                                                            >
                                                                {{ item.label }}
                                                            </v-chip>
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                            </v-select>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list>
                            </v-card-text>
                        </v-card>
                    </div>

                           <!-- 카테고리 설정 섹션 (이미지 퀴즈 또는 타일 퀴즈인 경우) -->
                           <div v-if="isCategoryBasedType(dialog_quiz_type) && dialog_step_count && dialog_step_count > 0" class="mb-3">
                        <div class="d-flex align-center mb-2">
                            <v-icon color="primary" class="mr-2" size="20">mdi-folder-multiple</v-icon>
                            <h3 class="text-subtitle-1 font-weight-bold">카테고리 설정</h3>
                        </div>
                        <v-divider class="mb-2"></v-divider>
                        
                        <!-- 문제 선택 버튼 -->
                        <div class="mb-3">
                            <label class="text-caption font-weight-bold mb-1 d-block">문제 선택</label>
                            <v-row dense>
                                <v-col
                                    v-for="(q, index) in dialog_step_count"
                                    :key="index"
                                    cols="auto"
                                >
                                    <v-btn
                                        :color="selectedQuestionIndex === index ? 'primary' : 'grey lighten-2'"
                                        depressed
                                        @click="selectedQuestionIndex = index"
                                    >
                                        {{ index + 1 }}번
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>

                        <!-- 카테고리 선택 영역 (Chip 형태) -->
                        <div class="pa-3 mb-2" style="border-radius: 8px; background-color: #f3f0fb;">
                            <label class="text-caption font-weight-bold mb-1 d-block">
                                {{ selectedQuestionIndex + 1 }}번 문제 카테고리 선택
                            </label>
                            <v-chip-group
                                :key="'chip-group-' + selectedQuestionIndex"
                                multiple
                                column
                            >
                                <v-chip
                                    v-for="category in category_groups"
                                    :key="category.PID + '-' + selectedQuestionIndex"
                                    :color="isCategorySelected(selectedQuestionIndex, category.PID) ? 'indigo darken-2' : 'indigo lighten-4'"
                                    :text-color="isCategorySelected(selectedQuestionIndex, category.PID) ? 'white' : 'black'"
                                    class="ma-1"
                                    @click="toggleCategory(selectedQuestionIndex, category.PID)"
                                >
                                    {{ category.NAME }}
                                </v-chip>
                            </v-chip-group>
                            <div v-if="category_groups.length === 0" class="text-center pa-4">
                                <v-icon color="grey">mdi-information-outline</v-icon>
                                <p class="text-caption grey--text mt-2">카테고리 그룹이 없습니다.</p>
                            </div>
                        </div>
                    </div>
                </v-card-text>

                <v-card-actions class="pa-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="grey"
                        text
                        small
                        @click="CloseMainQuizDialog"
                    >
                        취소
                    </v-btn>
                    <v-btn
                        color="primary"
                        small
                        @click="OnSave_MainQuiz"
                        :loading="loadingData"
                    >
                        저장
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- 슬라이드 편집 다이얼로그 -->
        <v-dialog v-model="dialog_slide" max-width="600" :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-card>
                <v-card-title class="text-h6 primary white--text py-2 px-4">
                    <v-icon left color="white" size="20">{{ slide_edit_index === -1 ? 'mdi-plus' : 'mdi-pencil' }}</v-icon>
                    {{ slide_edit_index === -1 ? '슬라이드 추가' : '슬라이드 편집' }}
                </v-card-title>
                <v-divider/>
                <v-card-text class="pa-4">
                    <v-text-field
                        label="타이틀 *"
                        v-model="slide_dialog_data.title"
                        outlined
                        dense
                        prepend-inner-icon="mdi-format-title"
                        class="mb-2"
                        :rules="[v => !!v || '타이틀을 입력해주세요']"
                    />
                    <v-file-input
                        label="썸네일 이미지 *"
                        accept="image/*"
                        prepend-icon="mdi-image"
                        outlined
                        dense
                        v-model="slide_dialog_temp_file"
                        @change="(file) => slide_dialog_temp_file = file"
                        class="mb-2"
                        :rules="slide_edit_index === -1 ? [v => !!v || '썸네일 이미지를 선택해주세요'] : []"
                    />
                    <div v-if="slide_dialog_data.thumb && !slide_dialog_temp_file" class="mb-2">
                        <img 
                            :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+slide_dialog_data.thumb" 
                            alt="Image"
                            style="width: 120px; height: 120px; border: 2px solid #E0E0E0; border-radius: 8px; object-fit: cover;"
                        />
                    </div>
                    <v-select
                        label="배지 상태 *"
                        v-model="slide_dialog_data.badge"
                        :items="badge_options"
                        item-text="label"
                        item-value="value"
                        outlined
                        dense
                        prepend-inner-icon="mdi-label"
                        class="mb-2"
                    />
                    <v-select
                        label="액션 타입 *"
                        v-model="slide_dialog_data.action_type"
                        :items="action_type_options"
                        item-text="label"
                        item-value="value"
                        outlined
                        dense
                        prepend-inner-icon="mdi-cursor-pointer"
                        class="mb-2"
                    />
                    <v-text-field
                        :label="getActionTypeParamLabel(slide_dialog_data.action_type)"
                        :placeholder="getActionTypeParamPlaceholder(slide_dialog_data.action_type)"
                        v-model="slide_dialog_data.action_param"
                        outlined
                        dense
                        prepend-inner-icon="mdi-link"
                        class="mb-2"
                        :hint="getActionTypeHint(slide_dialog_data.action_type)"
                        persistent-hint
                    />
                    <v-select
                        label="활성화 여부 *"
                        v-model="slide_dialog_data.is_enable"
                        :items="yes_no_options"
                        item-text="label"
                        item-value="value"
                        outlined
                        dense
                        prepend-inner-icon="mdi-toggle-switch"
                    />
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn text @click="CloseSlideDialog">취소</v-btn>
                    <v-btn color="primary" @click="SaveSlideDialog">저장</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import config from '../../config/config';
import { getMainQuizInfoTypeOptions, getQuizTypeLabel as getQuizTypeLabelFromConfig, isCategoryBasedType as checkIsCategoryBasedType, isLevelBasedType as checkIsLevelBasedType, needsLevelSetting } from '../../config/quiz_types';
import draggable from 'vuedraggable';
const { FileUpload_Async, FileUpload_JSON } = require("../../util/fileutil");

export default {
    name: 'Game_MainQuizInfo',

    data: () => ({
        activeTab: 0, // 0: 메인메뉴, 1: 오적완 슬라이드2(SlideList_2.json), 2: 오적완 슬라이드(비활성화)
        loadingData: false,
        main_quiz_list: [],
        category_groups: [],
        dialog_main_quiz: false,
        dialog_mode_edit: false,
        dialog_title: '',
        dialog_desc: '',
        dialog_thumb_file: null,
        dialog_thumb_url: '',
        dialog_quiz_type: null,
        dialog_grade: 1,
        dialog_step_count: null,
        dialog_participate: null,
        dialog_is_enable: 'Y',
        selected_categories: [],
        selected_main_quiz_pid: null,
        selectedQuestionIndex: 0,
        questionCategoryMap: [], // 각 문제별 카테고리 선택 상태 [{pid: 1, enable: true}, ...]
        question_level_map: [], // 각 문제별 레벨 정보 [{index: 0, level: 1}, {index: 1, level: 2}, ...]
        level_options: [
            { label: '레벨 1', value: 1 },
            { label: '레벨 2', value: 2 },
            { label: '레벨 3', value: 3 }
        ],
        yes_no_options: [
            { label: '활성화', value: 'Y' },
            { label: '비활성화', value: 'N' }
        ],
        // 퀴즈 타입 옵션 (config에서 가져오기)
        quiz_type_options: getMainQuizInfoTypeOptions(),

        // 슬라이드 관련 데이터
        loadingSlideData: false,
        savingSlideData: false,
        slide_data: {
            ad_placement: '',
            slides: []
        },
        // 오적완 슬라이드 (구) — SlideList.json 조회용
        loadingSlideDataLegacy: false,
        slide_data_legacy: {
            ad_placement: '',
            slides: []
        },
        dialog_slide: false,
        slide_edit_index: -1,
        slide_dialog_data: {
            title: '',
            thumb: '',
            badge: 'NORMAL',
            action_type: 'CONTENT',
            action_param: '',
            is_enable: 'Y'
        },
        slide_dialog_temp_file: null,
        badge_options: [
            { label: '일반', value: 'NORMAL' },
            { label: 'HOT', value: 'HOT' },
            { label: 'NEW', value: 'NEW' }
        ],
        action_type_options: [
            { label: '콘텐츠', value: 'CONTENT' },
            { label: '링크', value: 'LINK' },
            { label: '플레이스먼트', value: 'PLACEMENT' }
        ],
    }),

    created() {
        this.LoadMainQuizList();
        if (this.activeTab === 1) {
            this.LoadSlideList();
        }
    },

    methods: {
        ...mapActions([
            'GET_MAIN_QUIZ_LIST',
            'CREATE_MAIN_QUIZ',
            'EDIT_MAIN_QUIZ',
            'GET_QUIZ_GROUP_INFO',
        ]),

        LoadMainQuizList() {
            this.loadingData = true;
            
            // 메인 퀴즈 리스트와 카테고리 정보를 병렬로 가져오기
            Promise.all([
                this.GET_MAIN_QUIZ_LIST({}),
                this.GET_QUIZ_GROUP_INFO({})
            ])
                .then(([quizData, categoryData]) => {
                    this.loadingData = false;
                    console.log(JSON.stringify(categoryData));
                    // 메인 퀴즈 리스트
                    this.main_quiz_list = quizData.quiz_list || quizData.response_data?.quiz_list || [];
                    
                    // 카테고리 그룹 정보 (QuizList_Group.vue와 동일한 방식)
                    // ref_pid가 0인 것만 필터링 (나머지는 가짜 데이터)
                    const categoryList = categoryData.result?.cate || categoryData.cate || [];
                    this.category_groups = categoryList
                        .filter(cat => (cat.ref_pid === 0 || cat.ref_pid === '0' || cat.REF_PID === 0 || cat.REF_PID === '0'))
                        .sort((a, b) => {
                            const nameA = (a.NAME || a.category || a.category_comment || '').toLowerCase();
                            const nameB = (b.NAME || b.category || b.category_comment || '').toLowerCase();
                            return nameA.localeCompare(nameB, 'ko-KR');
                        })
                        .map(cat => ({
                            PID: cat.pid || cat.PID,
                            NAME: cat.category_comment || cat.category || cat.NAME || ''
                        }));
                    
                    console.log('메인 퀴즈 리스트 로드:', this.main_quiz_list);
                    console.log('카테고리 그룹 로드:', this.category_groups);
                })
                .catch((err) => {
                    this.loadingData = false;
                    console.error('메인 퀴즈 리스트 로드 실패:', err);
                    alert('메인 퀴즈 리스트를 불러오는데 실패했습니다.');
                });
        },

        OnClick_CreateMainQuiz() {
            this.dialog_mode_edit = false;
            this.selected_main_quiz_pid = null;
            this.dialog_title = '';
            this.dialog_desc = '';
            this.dialog_thumb_file = null;
            this.dialog_thumb_url = '';
            this.dialog_quiz_type = null;
            this.dialog_grade = 1;
            this.dialog_step_count = null;
            this.dialog_participate = 0; // 생성 시 0으로 설정
            this.dialog_is_enable = 'Y';
            this.selected_categories = [];
            this.selectedQuestionIndex = 0;
            this.questionCategoryMap = [];
            this.question_level_map = [];
            this.dialog_main_quiz = true;
        },

        OnClick_EditMainQuiz(item) {
            this.dialog_mode_edit = true;
            this.selected_main_quiz_pid = item.PID;
            this.dialog_title = item.TITLE || '';
            this.dialog_desc = item.DESC || '';
            this.dialog_thumb_file = null;
            this.dialog_thumb_url = item.THUMB || '';
            this.dialog_quiz_type = item.QUIZ_TYPE || null;
            this.dialog_grade = item.GRADE || 1;
            this.dialog_step_count = item.STEP_COUNT || null;
            this.dialog_participate = item.PARTICIPATE || null;
            this.dialog_is_enable = item.IS_ENABLE || 'Y';
            this.selectedQuestionIndex = 0;
            
            // CONTENT_INFO에서 문제별 정보 가져오기
            this.questionCategoryMap = [];
            this.question_level_map = [];
            
            if (item.CONTENT_INFO) {
                try {
                    const contentInfo = typeof item.CONTENT_INFO === 'string' 
                        ? JSON.parse(item.CONTENT_INFO) 
                        : item.CONTENT_INFO;
                    
                    const stepCount = item.STEP_COUNT || 0;
                    
                    // 이미지/타일 퀴즈: 카테고리 정보 로드
                    if (checkIsCategoryBasedType(item.QUIZ_TYPE)) {
                        for (let i = 0; i < stepCount; i++) {
                            const categoryStates = this.category_groups.map((cat) => {
                                let isEnabled = false;
                                
                                if (Array.isArray(contentInfo)) {
                                    const questionData = contentInfo.find(q => q.question_index === i);
                                    if (questionData && questionData.categories) {
                                        isEnabled = questionData.categories.some(c => c.PID === cat.PID);
                                    }
                                } else if (contentInfo[i]) {
                                    const questionCategories = Array.isArray(contentInfo[i]) ? contentInfo[i] : [];
                                    isEnabled = questionCategories.some(c => (c.PID || c) === cat.PID);
                                }
                                
                                return {
                                    pid: cat.PID,
                                    enable: isEnabled
                                };
                            });
                            this.$set(this.questionCategoryMap, i, categoryStates);
                        }
                        console.log('문제별 카테고리 맵 로드:', this.questionCategoryMap);
                    }
                    // 가로세로/객관식 퀴즈: 레벨 정보 로드 (DRAWING/NONSENSE는 완전히 제외)
                    else if (checkIsLevelBasedType(item.QUIZ_TYPE) && checkNeedsLevelSetting(item.QUIZ_TYPE)) {
                        let levels = null;
                        
                        // CONTENT_INFO가 배열 형태인 경우: [2,3,4,2,1]
                        if (Array.isArray(contentInfo)) {
                            levels = contentInfo;
                        }
                        // CONTENT_INFO가 객체 형태인 경우: {count: 5, levels: [2,3,4,2,1]}
                        else if (contentInfo && typeof contentInfo === 'object' && !Array.isArray(contentInfo)) {
                            levels = contentInfo.levels;
                        }
                        
                        if (levels && Array.isArray(levels) && levels.length > 0) {
                            this.question_level_map = levels.map((level, index) => ({
                                index: index,
                                level: level || 1
                            }));
                            console.log('문제별 레벨 맵 로드:', this.question_level_map);
                        } else {
                            // 레벨 정보가 없으면 문제 수만큼 기본 레벨 1로 초기화
                            this.updateQuestionLevelMap();
                        }
                    }
                    // DRAWING/NONSENSE는 레벨 관련 처리 완전히 제외
                } catch (e) {
                    console.error('CONTENT_INFO 파싱 실패:', e);
                    if (checkIsCategoryBasedType(item.QUIZ_TYPE)) {
                        this.initializeQuestionCategoryMap();
                    } else if (checkIsLevelBasedType(item.QUIZ_TYPE) && checkNeedsLevelSetting(item.QUIZ_TYPE)) {
                        this.updateQuestionLevelMap();
                    }
                    // DRAWING/NONSENSE는 레벨 관련 처리 완전히 제외
                }
            } else {
                // CONTENT_INFO가 없는 경우 초기화
                if (checkIsCategoryBasedType(item.QUIZ_TYPE)) {
                    this.initializeQuestionCategoryMap();
                } else if (checkIsLevelBasedType(item.QUIZ_TYPE) && checkNeedsLevelSetting(item.QUIZ_TYPE)) {
                    this.updateQuestionLevelMap();
                }
                // DRAWING/NONSENSE는 레벨 관련 처리 완전히 제외
            }
            
            this.dialog_main_quiz = true;
        },

        // 문제별 카테고리 맵 초기화
        initializeQuestionCategoryMap() {
            if (!this.dialog_step_count || this.dialog_step_count <= 0) {
                this.questionCategoryMap = [];
                return;
            }
            
            for (let i = 0; i < this.dialog_step_count; i++) {
                const categoryStates = this.category_groups.map((cat) => ({
                    pid: cat.PID,
                    enable: false
                }));
                this.$set(this.questionCategoryMap, i, categoryStates);
            }
        },
        
        // 문제 수 변경 시 카테고리 맵 업데이트
        updateQuestionCategoryMap() {
            if (!this.dialog_step_count || this.dialog_step_count <= 0) {
                this.questionCategoryMap = [];
                this.selectedQuestionIndex = 0;
                return;
            }
            
            const currentLength = this.questionCategoryMap.length;
            const newLength = this.dialog_step_count;
            
            // 선택된 문제 인덱스가 범위를 벗어나면 0으로 리셋
            if (this.selectedQuestionIndex >= newLength) {
                this.selectedQuestionIndex = 0;
            }
            
            if (newLength > currentLength) {
                // 문제 수가 늘어난 경우: 빈 카테고리 상태로 추가
                for (let i = currentLength; i < newLength; i++) {
                    const categoryStates = this.category_groups.map((cat) => ({
                        pid: cat.PID,
                        enable: false
                    }));
                    this.$set(this.questionCategoryMap, i, categoryStates);
                }
            } else if (newLength < currentLength) {
                // 문제 수가 줄어든 경우: 배열 자르기
                this.questionCategoryMap = this.questionCategoryMap.slice(0, newLength);
            } else if (currentLength === 0 && newLength > 0) {
                // 완전히 빈 배열에서 시작하는 경우: 전체 초기화
                this.initializeQuestionCategoryMap();
            }
        },
        
        // 카테고리 토글
        toggleCategory(questionIndex, categoryPid) {
            const list = this.questionCategoryMap[questionIndex] || [];
            const updated = list.map(item => ({
                ...item,
                enable: item.pid === categoryPid ? !item.enable : item.enable
            }));
            this.$set(this.questionCategoryMap, questionIndex, updated);
        },
        
        // 카테고리 선택 여부 확인
        isCategorySelected(questionIndex, categoryPid) {
            const list = this.questionCategoryMap[questionIndex] || [];
            return list.find(x => x.pid === categoryPid)?.enable === true;
        },
        
        // 문제 수 변경 시 레벨 맵 업데이트
        updateQuestionLevelMap() {
            if (!this.dialog_step_count || this.dialog_step_count <= 0) {
                this.question_level_map = [];
                return;
            }
            
            const currentLength = this.question_level_map.length;
            const newLength = this.dialog_step_count;
            
            if (newLength > currentLength) {
                // 문제 수가 늘어난 경우: 기본 레벨 1로 추가
                for (let i = currentLength; i < newLength; i++) {
                    this.question_level_map.push({
                        index: i,
                        level: 1
                    });
                }
            } else if (newLength < currentLength) {
                // 문제 수가 줄어든 경우: 배열 자르기
                this.question_level_map = this.question_level_map.slice(0, newLength);
            } else if (currentLength === 0 && newLength > 0) {
                // 완전히 빈 배열에서 시작하는 경우: 전체 초기화
                this.question_level_map = [];
                for (let i = 0; i < newLength; i++) {
                    this.question_level_map.push({
                        index: i,
                        level: 1
                    });
                }
            }
        },
        
        // 레벨별 색상 반환
        getLevelColor(level) {
            const colorMap = {
                1: 'green',      // 레벨 1: 초록색
                2: 'orange',     // 레벨 2: 주황색
                3: 'red'         // 레벨 3: 빨간색
            };
            return colorMap[level] || 'grey';
        },

        async OnSave_MainQuiz() {
            // 필수 필드 검증
            if (!this.dialog_title || !this.dialog_desc) {
                alert('필수 항목(제목, 부가설명)을 모두 입력해주세요.');
                return;
            }

            // 생성 시 퀴즈 타입 필수
            if (!this.dialog_mode_edit && !this.dialog_quiz_type) {
                alert('퀴즈 타입을 선택해주세요.');
                return;
            }

            // 생성 시 썸네일 검증
            if (!this.dialog_mode_edit && !this.dialog_thumb_file) {
                alert('썸네일 이미지를 선택해주세요.');
                return;
            }

            this.loadingData = true;

            let thumb_url = this.dialog_thumb_url;

            // 새 이미지가 업로드된 경우
            if (this.dialog_thumb_file) {
                // 파일 크기 체크 (1MB = 1048576 bytes)
                const maxFileSize = 1024 * 1024; // 1MB
                if (this.dialog_thumb_file.size > maxFileSize) {
                    this.loadingData = false;
                    alert('파일 크기가 1MB를 초과합니다. 더 작은 파일을 선택해주세요.');
                    return;
                }

                thumb_url = "project_quizncash/images/mainquiz/thumb/" + this.Utill_CreateNewImageName(this.dialog_thumb_file.name);
                try {
                    await FileUpload_Async(this.dialog_thumb_file, thumb_url);
                } catch (error) {
                    this.loadingData = false;
                    console.error('이미지 업로드 실패:', error);
                    alert('이미지 업로드에 실패했습니다.');
                    return;
                }
            }

            // CONTENT_INFO 구성
            let content_info = null;
            
            // 이미지/타일 퀴즈: 문제별 카테고리 정보 저장
            if (checkIsCategoryBasedType(this.dialog_quiz_type) && this.dialog_step_count && this.dialog_step_count > 0) {
                content_info = [];
                for (let i = 0; i < this.dialog_step_count; i++) {
                    const categoryStates = this.questionCategoryMap[i] || [];
                    const selectedCategories = categoryStates
                        .filter(cat => cat.enable)
                        .map(cat => {
                            const category = this.category_groups.find(c => c.PID === cat.pid);
                            return {
                                PID: cat.pid,
                                NAME: category ? category.NAME : ''
                            };
                        });
                    
                    content_info.push({
                        question_index: i,
                        categories: selectedCategories
                    });
                }
            }
            // 가로세로/객관식 퀴즈: 문제별 레벨 정보 저장 (DRAWING/NONSENSE는 완전히 제외)
            else if (checkIsLevelBasedType(this.dialog_quiz_type) && checkNeedsLevelSetting(this.dialog_quiz_type) && this.dialog_step_count && this.dialog_step_count > 0) {
                const levels = this.question_level_map.map(item => item.level);
                content_info = {
                    count: this.dialog_step_count,
                    levels: levels
                };
            }
            // DRAWING/NONSENSE는 content_info를 null로 설정 (레벨 관련 처리 완전히 제외)

            const params = {
                title: this.dialog_title,
                desc: this.dialog_desc,
                thumb: thumb_url || null,
                quiz_type: this.dialog_quiz_type,
                grade: this.dialog_grade,
                step_count: this.dialog_step_count || null,
                content_info: content_info,
                is_enable: this.dialog_is_enable
            };

            if (this.dialog_mode_edit) {
                // 수정 시에는 participate 필드를 전송하지 않음 (DB에서 자동 계산)
                params.pid = this.selected_main_quiz_pid;
                this.EDIT_MAIN_QUIZ(params)
                    .then((body_data) => {
                        this.loadingData = false;
                        console.log('메인 퀴즈 수정 성공:', body_data);
                        alert('메인 퀴즈가 수정되었습니다.');
                        this.CloseMainQuizDialog();
                        this.LoadMainQuizList();
                    })
                    .catch((err) => {
                        this.loadingData = false;
                        console.error('메인 퀴즈 수정 실패:', err);
                        alert('메인 퀴즈 수정에 실패했습니다: ' + err);
                    });
            } else {
                // 생성 시에는 participate를 0으로 설정
                params.participate = 0;
                this.CREATE_MAIN_QUIZ(params)
                    .then((body_data) => {
                        this.loadingData = false;
                        console.log('메인 퀴즈 생성 성공:', body_data);
                        alert('메인 퀴즈가 생성되었습니다.');
                        this.CloseMainQuizDialog();
                        this.LoadMainQuizList();
                    })
                    .catch((err) => {
                        this.loadingData = false;
                        console.error('메인 퀴즈 생성 실패:', err);
                        alert('메인 퀴즈 생성에 실패했습니다: ' + err);
                    });
            }
        },

        CloseMainQuizDialog() {
            this.dialog_main_quiz = false;
            this.dialog_mode_edit = false;
            this.selected_main_quiz_pid = null;
            this.dialog_title = '';
            this.dialog_desc = '';
            this.dialog_thumb_file = null;
            this.dialog_thumb_url = '';
            this.dialog_quiz_type = null;
            this.dialog_grade = 1;
            this.dialog_step_count = null;
            this.dialog_participate = null;
            this.dialog_is_enable = 'Y';
            this.selected_categories = [];
            this.selectedQuestionIndex = 0;
            this.questionCategoryMap = [];
            this.question_level_map = [];
        },

        formatDate(dateString) {
            if (!dateString) return '-';
            const date = new Date(dateString);
            return date.toLocaleString('ko-KR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            });
        },

        getQuizTypeLabel(type) {
            return getQuizTypeLabelFromConfig(type);
        },

        isCategoryBasedType(type) {
            return checkIsCategoryBasedType(type);
        },

        isLevelBasedType(type) {
            return checkIsLevelBasedType(type);
        },

        checkNeedsLevelSetting(type) {
            return needsLevelSetting(type);
        },

        // 슬라이드 관련 메서드
        async LoadSlideList() {
            this.loadingSlideData = true;
            const filePath = config.isLive 
                ? 'quizcash/manage/live/SlideList_2.json'
                : 'quizcash/manage/dev/SlideList_2.json';
            const url = `https://content-filecenter.s3.ap-northeast-2.amazonaws.com/${filePath}?t=${Date.now()}`;
            
            try {
                const response = await fetch(url, {
                    method: 'GET',
                    cache: 'no-store'
                });

                if (response.ok) {
                    const data = await response.json();
                    // 배열 형태면 기존 형식, 객체 형태면 새 형식
                    if (Array.isArray(data)) {
                        this.slide_data = {
                            ad_placement: '',
                            slides: data
                        };
                    } else {
                        this.slide_data = {
                            ad_placement: data.ad_placement || '',
                            slides: data.slides || []
                        };
                    }
                    // 로드 후 정렬
                    this.sortSlideList();
                    console.log('슬라이드 리스트 로드:', this.slide_data);
                } else {
                    // 파일이 없으면 빈 구조로 초기화
                    this.slide_data = {
                        ad_placement: '',
                        slides: []
                    };
                }
            } catch (error) {
                console.error('슬라이드 리스트 로드 실패:', error);
                this.slide_data = {
                    ad_placement: '',
                    slides: []
                };
            } finally {
                this.loadingSlideData = false;
            }
        },

        async LoadSlideListLegacy() {
            this.loadingSlideDataLegacy = true;
            const filePath = config.isLive 
                ? 'quizcash/manage/live/SlideList.json'
                : 'quizcash/manage/dev/SlideList.json';
            const url = `https://content-filecenter.s3.ap-northeast-2.amazonaws.com/${filePath}?t=${Date.now()}`;
            try {
                const response = await fetch(url, { method: 'GET', cache: 'no-store' });
                if (response.ok) {
                    const data = await response.json();
                    if (Array.isArray(data)) {
                        this.slide_data_legacy = { ad_placement: '', slides: data };
                    } else {
                        this.slide_data_legacy = {
                            ad_placement: data.ad_placement || '',
                            slides: data.slides || []
                        };
                    }
                } else {
                    this.slide_data_legacy = { ad_placement: '', slides: [] };
                }
            } catch (error) {
                console.error('슬라이드(구) 로드 실패:', error);
                this.slide_data_legacy = { ad_placement: '', slides: [] };
            } finally {
                this.loadingSlideDataLegacy = false;
            }
        },

        OnClick_CreateSlide() {
            this.slide_edit_index = -1;
            this.slide_dialog_data = {
                title: '',
                thumb: '',
                badge: 'NORMAL',
                action_type: 'CONTENT',
                action_param: '',
                is_enable: 'Y'
            };
            this.slide_dialog_temp_file = null;
            this.dialog_slide = true;
        },

        OnClick_EditSlide(index) {
            this.slide_edit_index = index;
            const item = this.slide_data.slides[index];
            this.slide_dialog_data = {
                title: item.title || '',
                thumb: item.thumb || '',
                badge: item.badge || 'NORMAL',
                action_type: item.action_type || 'CONTENT',
                action_param: item.action_param || '',
                is_enable: item.is_enable || 'Y'
            };
            this.slide_dialog_temp_file = null;
            this.dialog_slide = true;
        },

        OnClick_DeleteSlide(index) {
            if (confirm('이 슬라이드를 삭제하시겠습니까?')) {
                this.slide_data.slides.splice(index, 1);
            }
        },

        CloseSlideDialog() {
            this.dialog_slide = false;
            this.slide_edit_index = -1;
            this.slide_dialog_data = {
                title: '',
                thumb: '',
                badge: 'NORMAL',
                action_type: 'CONTENT',
                action_param: '',
                is_enable: 'Y'
            };
            this.slide_dialog_temp_file = null;
        },

        async SaveSlideDialog() {
            if (!this.slide_dialog_data.title) {
                alert('타이틀을 입력해주세요.');
                return;
            }

            if (this.slide_edit_index === -1 && !this.slide_dialog_temp_file) {
                alert('썸네일 이미지를 선택해주세요.');
                return;
            }

            let thumbPath = this.slide_dialog_data.thumb;
            
            // 새 이미지가 업로드된 경우
            if (this.slide_dialog_temp_file) {
                thumbPath = "quizcash/images/slides/"+this.Utill_CreateNewImageName(this.slide_dialog_temp_file.name);
                await FileUpload_Async(this.slide_dialog_temp_file, thumbPath);
            }

            const itemData = {
                title: this.slide_dialog_data.title,
                thumb: thumbPath,
                badge: this.slide_dialog_data.badge,
                action_type: this.slide_dialog_data.action_type,
                action_param: this.slide_dialog_data.action_param,
                is_enable: this.slide_dialog_data.is_enable
            };

            if (this.slide_edit_index === -1) {
                // 새 항목 추가
                this.slide_data.slides.push(itemData);
            } else {
                // 기존 항목 수정
                this.$set(this.slide_data.slides, this.slide_edit_index, itemData);
            }

            // 저장 후 정렬
            this.sortSlideList();
            this.CloseSlideDialog();
        },

        async OnSave_SlideList() {
            // 저장 전 정렬
            this.sortSlideList();
            
            this.savingSlideData = true;
            const filePath = config.isLive 
                ? 'quizcash/manage/live/SlideList_2.json'
                : 'quizcash/manage/dev/SlideList_2.json';
            
            // { ad_placement: '', slides: [] } 형태로 저장
            const jsonData = {
                ad_placement: this.slide_data.ad_placement,
                slides: this.slide_data.slides
            };
            
            try {
                if (await FileUpload_JSON(jsonData, filePath)) {
                    this.savingSlideData = false;
                    console.log(`S3 서버에 저장되었습니다. ${filePath}`);
                    alert('저장 완료');
                } else {
                    this.savingSlideData = false;
                    alert('저장 실패');
                }
            } catch (error) {
                this.savingSlideData = false;
                console.error('슬라이드 리스트 저장 실패:', error);
                alert('저장 실패: ' + error);
            }
        },

        onSlideDragEnd() {
            // 드래그 완료 후 비활성화된 항목들을 아래로 정렬
            this.sortSlideList();
            console.log('슬라이드 순서 변경:', this.slide_data.slides);
        },

        sortSlideList() {
            // 활성화된 항목들을 위로, 비활성화된 항목들을 아래로 정렬
            // 드래그 앤 드롭으로 변경된 순서는 유지하되, 활성/비활성 그룹만 분리
            const activeItems = [];
            const inactiveItems = [];
            
            this.slide_data.slides.forEach(item => {
                if (item.is_enable === 'Y') {
                    activeItems.push(item);
                } else {
                    inactiveItems.push(item);
                }
            });
            
            // 활성화된 항목들의 상대적 순서와 비활성화된 항목들의 상대적 순서는 유지
            this.slide_data.slides = [...activeItems, ...inactiveItems];
        },

        getBadgeColor(badge) {
            const colorMap = {
                'HOT': 'error',
                'NEW': 'info',
                'NORMAL': 'grey'
            };
            return colorMap[badge] || 'grey';
        },

        getBadgeLabel(badge) {
            const labelMap = {
                'HOT': 'HOT',
                'NEW': 'NEW',
                'NORMAL': '일반'
            };
            return labelMap[badge] || '일반';
        },

        getActionTypeLabel(actionType) {
            const labelMap = {
                'CONTENT': '콘텐츠',
                'LINK': '링크',
                'PLACEMENT': '플레이스먼트'
            };
            return labelMap[actionType] || actionType;
        },

        getActionTypeParamLabel(actionType) {
            const labelMap = {
                'CONTENT': '콘텐츠 ID',
                'LINK': '링크 URL',
                'PLACEMENT': '플레이스먼트 키'
            };
            return labelMap[actionType] || '파라미터';
        },

        getActionTypeParamPlaceholder(actionType) {
            const placeholderMap = {
                'CONTENT': '예: 123',
                'LINK': '예: https://...',
                'PLACEMENT': '예: quizcash_추천1'
            };
            return placeholderMap[actionType] || '';
        },

        getActionTypeHint(actionType) {
            const hintMap = {
                'CONTENT': '콘텐츠 ID를 입력하세요',
                'LINK': '링크 URL을 입력하세요',
                'PLACEMENT': '플레이스먼트 키를 입력하세요'
            };
            return hintMap[actionType] || '';
        },

        Utill_CreateNewImageName(originalFileName) {
            const timestamp = Date.now();
            const randomStr = Math.random().toString(36).substring(2, 15);
            const extension = originalFileName.split('.').pop();
            return `${timestamp}_${randomStr}.${extension}`;
        },
    },
    components: {
        draggable
    },
    computed: {
        slideListUrl() {
            const filePath = config.isLive 
                ? 'quizcash/manage/live/SlideList_2.json'
                : 'quizcash/manage/dev/SlideList_2.json';
            return `https://content-filecenter.s3.ap-northeast-2.amazonaws.com/${filePath}?t=${Date.now()}`;
        },
        slideListLegacyUrl() {
            const filePath = config.isLive 
                ? 'quizcash/manage/live/SlideList.json'
                : 'quizcash/manage/dev/SlideList.json';
            return `https://content-filecenter.s3.ap-northeast-2.amazonaws.com/${filePath}?t=${Date.now()}`;
        },
    },

    watch: {
        activeTab(newVal) {
            if (newVal === 1 && this.slide_data.slides.length === 0 && !this.loadingSlideData) {
                this.LoadSlideList();
            }
            if (newVal === 2 && !this.loadingSlideDataLegacy) {
                this.LoadSlideListLegacy();
            }
        },
        dialog_quiz_type(newVal) {
            // 퀴즈 타입이 변경되면 맵 초기화
            if (checkIsCategoryBasedType(newVal)) {
                this.updateQuestionCategoryMap();
                this.question_level_map = [];
            } else if (checkIsLevelBasedType(newVal) && checkNeedsLevelSetting(newVal)) {
                this.updateQuestionLevelMap();
                this.questionCategoryMap = [];
            } else {
                this.questionCategoryMap = [];
                this.question_level_map = [];
            }
            // DRAWING/NONSENSE는 레벨 관련 처리 완전히 제외
        },
        dialog_step_count(newVal) {
            // 문제 수가 변경되면 맵 업데이트
            if (checkIsCategoryBasedType(this.dialog_quiz_type)) {
                this.updateQuestionCategoryMap();
            } else if (checkIsLevelBasedType(this.dialog_quiz_type) && checkNeedsLevelSetting(this.dialog_quiz_type)) {
                this.updateQuestionLevelMap();
            }
            // DRAWING/NONSENSE는 레벨 관련 처리 완전히 제외
        },
        selectedQuestionIndex(val) {
            console.log(`🔁 문제 ${val + 1}번으로 이동`);
        }
    }
};
</script>

<style scoped>
/* 탭 스타일 */
.tab-item {
    color: rgba(0, 0, 0, 0.87) !important;
    font-weight: 500;
    transition: all 0.3s ease;
}

.tab-item:hover {
    background-color: rgba(0, 0, 0, 0.04);
}

.tab-text {
    font-size: 15px;
    letter-spacing: 0.5px;
}

/* 툴바 스타일 */
.toolbar-custom {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.toolbar-title-custom {
    color: rgba(0, 0, 0, 0.87) !important;
    font-weight: 600;
    font-size: 18px;
}

.toolbar-text {
    color: rgba(0, 0, 0, 0.87);
    margin-left: 8px;
}

/* 탭 활성화 시 색상 */
.v-tabs >>> .v-tab--active {
    color: #1976d2 !important;
    font-weight: 600;
}

.v-tabs >>> .v-tab {
    color: rgba(0, 0, 0, 0.6) !important;
}

.v-tabs >>> .v-tab:hover {
    color: rgba(0, 0, 0, 0.87) !important;
}

/* 슬라이더 색상 */
.v-tabs >>> .v-slide-group__wrapper {
    border-bottom: 2px solid rgba(0, 0, 0, 0.12);
}

/* 슬라이드 리스트 스타일 */
.slide-list-container {
    min-height: 100px;
}

.slide-item {
    transition: background-color 0.2s;
}

.slide-item:hover {
    background-color: rgba(0, 0, 0, 0.02);
}

.drag-handle {
    cursor: move;
}

.drag-handle:hover {
    color: #1976d2 !important;
}

/* 비활성화된 슬라이드 아이템 스타일 */
.slide-item-disabled {
    background-color: #f5f5f5 !important;
    opacity: 0.7;
}

.slide-item-disabled:hover {
    background-color: #eeeeee !important;
}
</style>

